import { LogLevel, LogLevelPriority } from '../../../../constants';
import { ConsoleLoggerConfig } from '../../../types';

export const config: ConsoleLoggerConfig = {
  stackExclusionPatterns:
    /\b(PinoAdapter|ConsoleLogger|LoggerChain|Logger|Proxy|Child|pino\.js)\b/,
  themes: {
    dark: {
      baseStyles: {
        timestamp: 'color: #A9A9A9; font-weight: normal;', // LightGray
        source: 'color: #B0B0B0; font-weight: normal;', // Gray, less emphasis
        context: 'color: #FFFFFF; font-weight: bold;', // White, more emphasis
        defaultMessage: 'color: #E5E5E5; font-weight: normal;', // Subtle light text
      },
      levels: {
        [LogLevelPriority[LogLevel.TRACE]]:
          'color: #778899; font-weight: bold;', // SlateGray
        [LogLevelPriority[LogLevel.DEBUG]]:
          'color: #008B8B; font-weight: bold;', // DarkCyan
        [LogLevelPriority[LogLevel.INFO]]: 'color: #00FFFF; font-weight: bold;', // Cyan
        [LogLevelPriority[LogLevel.WARN]]: 'color: #FFD700; font-weight: bold;', // Gold
        [LogLevelPriority[LogLevel.ERROR]]:
          'color: #FF4500; font-weight: bold;', // OrangeRed
        [LogLevelPriority[LogLevel.FATAL]]:
          'color: #FF0000; font-weight: bold; text-shadow: 1px 1px 1px black;', // Bright Red with shadow
      },
      messages: {
        [LogLevelPriority[LogLevel.WARN]]:
          'color: #FFD700; font-weight: normal;', // Gold, no bold
        [LogLevelPriority[LogLevel.ERROR]]:
          'color: #FF4500; font-weight: normal;', // OrangeRed, no bold
        [LogLevelPriority[LogLevel.FATAL]]:
          'color: #FF0000; font-weight: bold;', // Bright Red
      },
    },
    light: {
      baseStyles: {
        timestamp: 'color: #4D4D4D; font-weight: normal;', // DarkGray for contrast
        source: 'color: #666666; font-weight: normal;', // Medium Gray, less emphasis
        context: 'color: #000000; font-weight: bold;', // Black, more emphasis
        defaultMessage: 'color: #333333; font-weight: normal;', // Dark text
      },
      levels: {
        [LogLevelPriority[LogLevel.TRACE]]:
          'color: #6A5ACD; font-weight: bold;', // SlateBlue
        [LogLevelPriority[LogLevel.DEBUG]]:
          'color: #00509E; font-weight: bold;', // Rich Blue
        [LogLevelPriority[LogLevel.INFO]]: 'color: #1E90FF; font-weight: bold;', // DodgerBlue
        [LogLevelPriority[LogLevel.WARN]]: 'color: #FFA500; font-weight: bold;', // Orange
        [LogLevelPriority[LogLevel.ERROR]]:
          'color: #ff0033; font-weight: bold;', // FireBrick
        [LogLevelPriority[LogLevel.FATAL]]:
          'color: #D80000; font-weight: bold; text-shadow: 1px 1px 1px #660000;', // Strong Red with shadow
      },
      messages: {
        [LogLevelPriority[LogLevel.WARN]]:
          'color: #FFA500; font-weight: normal;', // Orange, no bold
        [LogLevelPriority[LogLevel.ERROR]]:
          'color: #ff0033; font-weight: normal;', // FireBrick, no bold
        [LogLevelPriority[LogLevel.FATAL]]:
          'color: #D80000; font-weight: bold;', // Strong Red
      },
    },
  },
};
